exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".simulators-heading {\n  font-size: 1.6rem;\n  padding-top: 2rem;\n}\n\n.simulators-button-wrapper {\n  display: flex;\n  width: 30%;\n  justify-content: space-between;\n  margin: 2rem 0;\n}\n\n.simulators-button {\n  width: 12rem;\n  height: 4rem;\n  font-size: 1rem !important;\n  font-weight: bold !important;\n}\n", ""]);

// exports
